
























































import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';

import { UiButton, UiIconButton, UiMenu } from '../keen-ui';

import { DeviceEnum } from '../../enums';

export default {
  name: 'ranking-layer',
  components: {
    UiButton,
    UiIconButton,
    UiMenu
  },
  computed: {
    getSelectedActionText: function (): string {
      return this.messages.products.item[this.selectedAction].selected;
    },
    isBoostedProduct: function (): boolean {
      return this.selectedAction === RankingActionEnum.BOOST;
    },
    isBuriedProduct: function (): boolean {
      return this.selectedAction === RankingActionEnum.BURY;
    },
    isHandheldDevice: function (): boolean {
      return this.$epb.device <= DeviceEnum.SMALL_TABLET;
    },
    isSelectedAction: function (): boolean {
      return this.isBoostedProduct || this.isBuriedProduct;
    }
  },
  props: {
    visible: Boolean,
    selectedAction: String,
    readonly: Boolean
  },
  data: function () {
    const messages = this.$epb.messages.tools.productsRanking;
    return {
      DeviceEnum,
      RankingActionEnum,
      messages: messages,
      dropdownMenuOptions: Object.keys(RankingActionEnum).map((action: RankingActionEnum) => ({
        label: messages.products.item[action].select,
        value: action
      }))
    };
  },
  methods: {
    toggleAction: function (action?: RankingActionEnum): void {
      this.$parent.toggleSelected(action);
    },
    getActionText: function (action: RankingActionEnum): string {
      return this.messages.products.item[action].select;
    }
  }
};
